import { BaseRepository } from '@wephone-core/model/repository/base_repository';

export class VoiceMailBoxRepository extends BaseRepository {
  ENTITY_CLASS = VoiceMailBoxEntity;
  protected USE_PUSH_API = false;
  protected URL_PREFIX: string = 'voicemail_box';
}

import { VoiceMailBoxEntity } from '@wephone-core/model/entity/voicemail_box';
